import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import About from "components/HOCs/About/About";
import BranchOffices from "components/HOCs/BranchOffices/BranchOffices";
import Catalogue from "components/HOCs/Catalogue/Catalogue";
import HomePage from "components/HOCs/HomePage/HomePage";
import PriceList from "components/HOCs/PriceList/PriceList";
import MenuNav from "components/HOCs/MenuNav/MenuNav";
import Login from "components/HOCs/Login/Login";
import ControlPanel from "components/HOCs/ControlPanel/ControlPanel";
import Error404 from "components/HOCs/404/Error404";
import EditCatalogue from "components/HOCs/Catalogue/EditCatalogue";
import EditBranchOffices from "components/HOCs/BranchOffices/EditBranchOffices";
import Footer from "components/HOCs/Footer/Footer";
import Regulations from "components/HOCs/Regulations/Regulations";

const Routes = () => {
	const [onAuth, setOnAuth] = useState(false);

	const routes = [
		{
			path: "/",
			exact: true,
			sidebar: () => <>Inicio</>,
			main: () => <HomePage/>,
		},
		{
			path: "/catalogo",
			exact: true,
			sidebar: () => <>Catálogo de Flexores</>,
			main: () => <Catalogue />,
		},
		{
			path: "/sucursales",
			exact: true,
			sidebar: () => <>Sucursales</>,
			main: () => <BranchOffices />,
		},
		{
			path: "/sobre-nosotros",
			exact: true,
			sidebar: () => <>Sobre Nosotros</>,
			main: () => <About />,
		},
		{
			path: "/panel-control-catalogo",
			exact: true,
			sidebar: () => <>Editar Catálogo</>,
			main: () => <EditCatalogue />,
		},
		{
			path: "/panel-control",
			exact: true,
			sidebar: () => <>Panel de Control</>,
			main: () => <ControlPanel />,
		},
		{
			path: "/panel-control-sucursales",
			exact: true,
			sidebar: () => <>Editar Sucursales</>,
			main: () => <EditBranchOffices />,
		},
		{
			path: "/ingresar",
			exact: true,
			sidebar: () => <>Ingresar</>,
			main: () => <Login setAuth={setOnAuth} onAuth={onAuth} />,
		},
		{
			path: "/terminos-y-condiciones",
			exact: true,
			sidebar: () => <>Regulaciones</>,
			main: () => <Regulations />,
		},
		{
			path: "/lista-precios",
			exact: true,
			sidebar: () => <>Lista de Precios</>,
			main: () => <PriceList />,
		},
		{
			path: "*",
			exact: true,
			sidebar: () => <>No encontrado</>,
			main: () => <Error404 />,
		},
	];

	useEffect(() => {
		setOnAuth(JSON.parse(window.localStorage.getItem("account")));
	}, []);

	return (
		<Router>
			<MenuNav onAuth={onAuth} setAuth={setOnAuth} routes={routes} />

			<div className="wrapContent">
				<Switch>
					{routes.map((route, index) => (
						<Route
							key={index}
							path={route.path}
							exact={route.exact}
							children={<route.main />}
						/>
					))}
				</Switch>
			</div>
			<Footer />
		</Router>
	);
};

export default Routes;
